import React from "react";
import { Link } from "react-router-dom";
import Carousel from "../components/carousel/Carousel.js";
import Testimonals from "../components/Testimonials/Testimonals.js";
import Footer from "../components/utils/Footer.js";
import servicesList from "../components/carousel/servicesList.js";
import heroLogo from "../images/MSY-Apparel-In-Gold.png";
import MayHaveSeenUsOn from "../components/MayHaveSeenUsOn.js";
import NavBar from "../components/utils/NavBar.js";

const HomePage = () => {
  return (
    <div className=" h-[calc(100dvh)]  bg-black w-full overscroll-contain overflow-x-hidden">
      <NavBar />
      <div
        className="h-3/5   max-w-screen-2xl mx-auto 
flex items-center justify-center
  bg-hero bg-opacity-80  bg-cover bg-center"
      >
        <img className="h-[200px] lg:h-[300px]" src={heroLogo} alt="hero" />
      </div>{" "}
      <Carousel
        CarouselTitle={"What We Do."}
        breakPoint={"lg:justify-center"}
        CarouselCardList={servicesList}
      />
      <section class="bg-primary">
        <div class="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6">
          <div class="max-w-screen-md mx-auto">
            <h2 class="mb-4 text-4xl font-body lg:text-6xl tracking-tight font-extrabold ">
              Let's create together.
            </h2>
            <p class="mb-8 lg:text-2xl mx-auto font-bold ">
              MSY, with a proven track record of excellence in the apparel
              industry, offers personalized service, expert craftsmanship, and a
              dedication to bringing your creative vision to life. With a keen
              eye for detail and a passion for quality, we collaborate closely
              with clients, ensuring every piece reflects their brand's unique
              identity and exceeds their expectations
            </p>
            <div class="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
              <Link
                to="/get-a-quote"
                class="inline-flex items-center justify-center px-4 py-2.5  font-medium lg:font-bold text-center text-black bg-white rounded-lg hover:bg-black hover:text-white hover:scale-110 focus:ring-4 focus:ring-primary-300 "
              >
                Get a quote
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Testimonals />
      <MayHaveSeenUsOn />
      <Footer />
    </div>
  );
};

export default HomePage;
